// Module
var code = "<span class=\"option\" ng-bind-html=\"match.model.text | uibTypeaheadHighlight:query\"></span>";
// Exports
export default code;